import { getDescriptorId } from './filter/getDescriptorId';
import { TodoDescriptor } from '../schema/TodoDescriptor';
import { getTasksService, GetTasksResponse } from 'owa-todo-service';
import { todoDescriptorToRequestParams } from './buildRequest/todoDescriptorToRequestParams';
import { RequestQueue, createRequestQueue } from 'owa-service-utils';

let currentRequests: { [requestId: string]: Promise<GetTasksResponse> } = {};

const MAX_NUM_REQUESTS = 3;
let fetchTasksForDescriptorQueue: RequestQueue | null = null;

export function fetchTasksForDescriptor(descriptor: TodoDescriptor): Promise<GetTasksResponse> {
    const requestId = getDescriptorId(descriptor);
    const existingRequest = currentRequests[requestId];
    if (existingRequest) {
        return existingRequest;
    } else {
        const fetchPromise = (async () => {
            try {
                const request = getQueue().add(() =>
                    getTasksService(todoDescriptorToRequestParams(descriptor))
                );
                currentRequests[requestId] = request;
                // disabling tslint rule as we need to await here
                // for the finally block to work properly
                // https://github.com/palantir/tslint/issues/3933
                // tslint:disable-next-line:no-return-await
                return await request;
            } finally {
                delete currentRequests[requestId];
            }
        })();
        return fetchPromise;
    }
}

function getQueue(): RequestQueue {
    if (fetchTasksForDescriptorQueue == null) {
        fetchTasksForDescriptorQueue = createRequestQueue(MAX_NUM_REQUESTS);
    }
    return fetchTasksForDescriptorQueue;
}
